import styled from 'styled-components'

// styles
import { BREAKPOINTS } from '../../../../styles/constants'

export const PastReservationsGrid = styled.div`
	display: grid;
	gap: 20px;

	@media (min-width: ${BREAKPOINTS.sm}) {
		grid-template-columns: 1fr 1fr;
	}

	@media (min-width: ${BREAKPOINTS.lg}) {
		gap: 40px;
	}
`

export const BottomNavigation = styled.div`
	position: relative;
	margin-top: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 48px;
`

export const PaginationWrapper = styled.div`
	display: none;

	@media (min-width: ${BREAKPOINTS.lg}) {
		display: block;
		position: absolute;
		right: 0;
	}
`
